import {createSelector} from 'reselect';

// Documentation redux state
const documentationReducerSelector = state => state.documentation;

// Documentation List
const documentationSelector = createSelector(
    documentationReducerSelector,
    documentationReducer => documentationReducer.get('payload')
);

// Documentation is fetching
const documentationIsFetchingSelector = createSelector(
    documentationReducerSelector,
    documentationReducer => documentationReducer.get('isFetching')
);

// Documentation error
const documentationErrorSelector = createSelector(
    documentationReducerSelector,
    documentationReducer => documentationReducer.get('error')
);

export {
    documentationSelector,
    documentationIsFetchingSelector,
    documentationErrorSelector
};